import React, { useEffect } from "react";
import { EditText, EditTextarea } from "react-edit-text";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateMtfQuestion, updateSelectedComponentType } from "../../../../redux/slices/userActivity";

const maxQuestionChar = 200;

const MtfQuestion = ({ question, styles }) => {
  const { selectedUserActivity } = useSelector((state) => state.userActivity);
  const { modalOpen: previewModalOpen } = useSelector((state) => state.preview);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    // console.log(e.target.value);
    if (e.target.value.length > maxQuestionChar) return;
    dispatch(updateMtfQuestion({ selectedActivityIdx: selectedUserActivity, question: e.target.value }));
  };

  useEffect(() => {
    dispatch(
      updateSelectedComponentType({
        type: "slide",
        name: "container",
      })
    );
  }, []);

  const handleClick = () => {
    dispatch(
      updateSelectedComponentType({
        type: "text",
        name: "question",
      })
    );
  };
  const reset = () => {
    dispatch(
      updateMtfQuestion({
        selectedActivityIdx: selectedUserActivity,
        question: "Type your question here...",
      })
    );
  };
  // console.log(styles.question)

  return (
    <div className="" onClick={handleClick}>
      <EditTextarea
        id="question-input-field"
        inputClassName='mcq-question-text-area'
        onEditMode={() => setTimeout(() => document.querySelector("#question-input-field").select(), 100)}
        onBlur={() => {
          question === "" && reset();
        }}
        value={question}
        // className="editable_text__question"
        style={{
          ...(styles ? {...styles.question} : {}),
          styles: styles ? {...styles.question} : {} ,
          backgroundColor: "transparent",
          // width: "auto",
          minWidth: "50px",
          width: 'auto',
          display: "block",
          overflowY: "visible",
          wordBreak: "break-word",
          outline: "none",
          border: "0",
        }}
        onChange={handleChange}
        readonly={previewModalOpen ? true : false}
      />
    </div>
  );
};

export default MtfQuestion;
